import { inject, Injectable } from '@angular/core';
import { WindowsSalesEndpoints } from 'app/core/enums/endpoints';
import { DeleteSaleBody } from 'app/core/interfaces/finances';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WindowsSalesService {
    private _endpoint = WindowsSalesEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------

    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    getAll(playdateId: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    create(windowsSaleData: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, windowsSaleData);
    }

    update(windowsSaleData: string, id: number): Observable<any> {
        return this._apiService.update(
            this._endpoint.patch,
            windowsSaleData,
            id
        );
    }

    delete(data: DeleteSaleBody): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, data);
    }
}
